// @flow

import { includes } from 'lodash';
import {
  TRACKED_LINK_CLICKED,
  CUSTOM_LINK_EVENT,
  EXIT_LINK_EVENT
} from 'src/store/location/location';

export const APP_BANNER_IMPRESSION = 'APP_BANNER_IMPRESSION';

const isCustomLink = (type: AppBannerTrackingType): boolean =>
  includes(['close'], type);

export const trackBannerEvent = (
  type: AppBannerTrackingType,
  device: MobileDevices
) => {
  return {
    type: TRACKED_LINK_CLICKED,
    payload: {
      analytics: `appbanner|${type}|${device}`,
      href: isCustomLink(type) ? CUSTOM_LINK_EVENT : EXIT_LINK_EVENT
    },
    meta: {
      metrics: {
        name: `app_banner_${type}`,
        tags: { device }
      }
    }
  };
};

export const trackBannerImpression = (
  appBanner: Analytics$AppBannerImpression
) => {
  return {
    type: APP_BANNER_IMPRESSION,
    payload: appBanner,
    meta: {
      metrics: {
        name: `app_banner_${appBanner.type}`,
        tags: { device: appBanner.deviceType }
      }
    }
  };
};
